import {
  ENROLL_CUSTOMER,
  ENROLL_CUSTOMER_FULFILLED,
  ENROLL_CUSTOMER_REJECTED,
  ENROLL_CUSTOMER_STATE_RESET,
  ADD_CUSTOMER,
  ADD_CUSTOMER_TO_SALE,
  ADD_CUSTOMER_TO_SALE_FULFILLED,
  ADD_CUSTOMER_TO_SALE_REJECTED,
  GET_CUSTOMER,
  GET_CUSTOMER_FULFILLED,
  GET_CUSTOMER_REJECTED,
  GET_CUSTOMER_STATE_RESET,
  RESET_CUSTOMER,
  REMOVE_CUSTOMER_FROM_SALE,
  REMOVE_CUSTOMER_FROM_SALE_FULFILLED,
  REMOVE_CUSTOMER_FROM_SALE_REJECTED,
  SET_POINT_BALANCE,
  CustomerActionTypes,
  CustomerState,
} from './';

const initialState: CustomerState = {
  customer: undefined,
  pointBalance: undefined,
  isAddedToSale: false,
  addCustomerToSaleState: {
    isPending: false,
    error: undefined,
  },
  removeCustomerFromSaleState: {
    isPending: false,
    error: undefined,
  },
  enrollCustomerState: {
    isPending: false,
    apiSuccess: undefined,
    error: undefined,
  },
  getCustomerState: {
    isPending: false,
    apiSuccess: undefined,
    error: undefined,
  },
};

export function customerReducer(
  state = initialState,
  action: CustomerActionTypes
): CustomerState {
  switch (action.type) {
    case ENROLL_CUSTOMER: {
      return {
        ...state,
        enrollCustomerState: {
          isPending: true,
          apiSuccess: undefined,
          error: undefined,
        },
      };
    }
    case ENROLL_CUSTOMER_FULFILLED: {
      return {
        ...state,
        enrollCustomerState: {
          apiSuccess: true,
          isPending: false,
          error: undefined,
        },
      };
    }
    case ENROLL_CUSTOMER_REJECTED: {
      const error = action.payload.error;

      return {
        ...state,
        enrollCustomerState: {
          apiSuccess: false,
          isPending: false,
          error,
        },
      };
    }
    case ENROLL_CUSTOMER_STATE_RESET: {
      return {
        ...state,
        enrollCustomerState: {
          ...initialState.enrollCustomerState,
        },
      };
    }
    case ADD_CUSTOMER:
      return {
        ...state,
        customer: action.payload.customer,
        context: action.payload.context,
      };

    case ADD_CUSTOMER_TO_SALE:
      return {
        ...state,
        addCustomerToSaleState: {
          isPending: true,
          error: undefined,
        },
      };

    case ADD_CUSTOMER_TO_SALE_FULFILLED:
      return {
        ...state,
        isAddedToSale: true,
        addCustomerToSaleState: {
          isPending: false,
        },
      };

    case ADD_CUSTOMER_TO_SALE_REJECTED:
      return {
        ...state,
        addCustomerToSaleState: {
          isPending: false,
          error: action.payload.error,
        },
      };

    case GET_CUSTOMER:
      return {
        ...state,
        getCustomerState: {
          isPending: true,
          apiSuccess: undefined,
          error: undefined,
        },
      };

    case GET_CUSTOMER_FULFILLED:
      return {
        ...state,
        getCustomerState: {
          isPending: false,
          apiSuccess: true,
          error: undefined,
        },
      };

    case GET_CUSTOMER_REJECTED:
      return {
        ...state,
        context: action.payload.context,
        getCustomerState: {
          isPending: false,
          apiSuccess: false,
          error: action.payload.error,
        },
      };

    case GET_CUSTOMER_STATE_RESET:
      return {
        ...state,
        getCustomerState: {
          ...initialState.getCustomerState,
        },
      };

    case RESET_CUSTOMER:
      return {
        ...state,
        customer: undefined,
        pointBalance: undefined,
      };

    case REMOVE_CUSTOMER_FROM_SALE:
      return {
        ...state,
        removeCustomerFromSaleState: {
          isPending: true,
          error: undefined,
        },
      };

    case REMOVE_CUSTOMER_FROM_SALE_FULFILLED:
      return {
        ...state,
        isAddedToSale: false,
        removeCustomerFromSaleState: {
          isPending: false,
        },
      };

    case REMOVE_CUSTOMER_FROM_SALE_REJECTED:
      return {
        ...state,
        removeCustomerFromSaleState: {
          isPending: false,
          error: action.payload.error,
        },
      };

    case SET_POINT_BALANCE:
      return {
        ...state,
        pointBalance: action.payload.pointBalance,
      };

    default:
      return state;
  }
}
